<template>
    <div
        class="BaseInput"
        :class="{ 'is-required' : field.required, 'has-error' : error && !isFocus, 'on-focus' : isFocus }"
    >
        <label
            :for="field.label"
        >
            {{ field.label }}
        </label>
        <textarea
            v-if="field.type === 'textarea'"
            :value="value"
            :name="field.name"
            @focusin="isFocus = true"
            @input="onInput"
        />
        <input
            v-else
            :value="value"
            :type="field.type"
            :name="field.name"
            @focusin="isFocus = true"
            @input="onInput"
        />
    </div>
</template>
<script>

export default {
    name: 'BaseInput',
    data() {
        return {
            isFocus: false
        }
    },
    props: {
        field: {
            type: Object
        },
        error: {
            type: Boolean
        },
        value: {
            type: String
        },
    },
    methods: {
        onInput() {
            this.$emit('input', event.target.value)
            this.isFocus = event.target.value.length ? true : false
        }
    },
    created() {
        if (this.value.length) {
            this.isFocus = true
        }
    }
}
</script>
<style lang="scss" scoped>
    .BaseInput {
        position: relative;
        border: thin solid $border-color;
        margin-bottom: getSpacing(medium);
        border-radius: 4px;

        @include media-query(palm) {
            width: calc(100% - 8px);
        }


        @include media-query(lap) {
            width: calc(100% - 12px);
        }



        input, textarea {
            padding: 1rem;
            padding-top: 1.25rem;
            padding-bottom: 0.75rem;
            width: 100%;
            font-size: 1rem;
            font-family: $base-font-family;
            color: $action-color;
            border: 0;
            outline: 0;
            box-shadow: none;
            border-radius: 4px;
        }

        textarea {
            min-height: 200px;
        }

        &.is-required {
            &:after {
                content: '';
                position: absolute;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: $error-color;
                top: calc(50% - 4px);
                right: - getSpacing(base);
            }
        }

        &.has-error {
            border-color: $error-color;

            &:before  {
                content: 'This field cannot be empty';
                position: absolute;
                color: $error-color;
                font-size: 0.65rem;
                font-weight: 600;
                bottom: -1rem;
            }
        }
    }

    label {
        position: absolute;
        padding: 1rem;
        line-height: 1.25;
        font-size: 1rem;
        font-family: $base-font-family;
        color: $base-font-color;
        pointer-events: none;
        transition: padding ease-out 0.265s;

        .on-focus & {
            font-size: 0.5rem;
            padding-top: 0.75rem;
        }
    }
</style>
